import {
  Dialog, DialogTitle, DialogContent, DialogActions,
  Button, TableContainer, Table, TableHead, TableRow, TableCell, TableBody, Alert,
} from '@mui/material';
import { useContext } from 'react';
import { ScheduleCreateContext, ScheduleCreateValues } from '../../contexts/ScheduleCreateContext';
import { CloseDialogAction } from '../../../../components/shared/dialogs/CloseDialogAction';

const ScheduleCreateViewItemsOfCountZone = () => {
  const {
    t,
    isCountZonesWithItemsModalOpen,
    countZoneItemsData,
    handleClose,
  } = useContext(ScheduleCreateContext) as ScheduleCreateValues;

  const close = () => {
    handleClose();
  };

  return (
    <Dialog open={isCountZonesWithItemsModalOpen}
      onClose={close}
      maxWidth='md'
      fullWidth>
      <DialogTitle>
        {t('countZones.items')}
        <CloseDialogAction onCancel={close} />
      </DialogTitle>
      <DialogContent>
        {countZoneItemsData.length === 0 ? (
          <Alert severity='info'
            variant='outlined'
            sx={{ mb: '12px' }}>
            {t('countZones.noItems')}
          </Alert>
        ) : (
          <TableContainer sx={{ overflowY: 'auto', border: '1px solid', maxHeight: '400px' }}>
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell>{t('countZones.rowNumber')}</TableCell>
                  <TableCell>{t('countZones.itemNumber')}</TableCell>
                  <TableCell>{t('countZones.itemDescription')}</TableCell>
                  <TableCell>{t('countZones.category')}</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {countZoneItemsData.map((item, index) => (
                  <TableRow key={`${item.itemNumber}-${index}`}>
                    <TableCell>{index + 1}</TableCell>
                    <TableCell>{item.itemNumber}</TableCell>
                    <TableCell>{item.itemDescription}</TableCell>
                    <TableCell>{item.primaryCategory}</TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        )}
      </DialogContent>
      <DialogActions>
        <Button size='lg'
          variant="secondary"
          onClick={close}>{t('cancel')}</Button>
      </DialogActions>
    </Dialog>
  );
};

export default ScheduleCreateViewItemsOfCountZone;
